import { Container, Sprite } from "pixi.js";
import { StealResourcePackage } from "../resources/StealResourcePackage";

export class LightComponent extends Container {
    private lightSprite: Sprite;

    public constructor(stealResources: StealResourcePackage) {
        super();
        this.lightSprite = new Sprite(stealResources.assets_views_steal_popup_light_1_png);
        this.lightSprite.anchor.set(0.5);
        this.addChild(this.lightSprite);
    }
}